import { SignOut } from "@aws-amplify/ui-react/dist/types/components/Authenticator/Authenticator";
import {
  AppBar,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import { useEffect, useState } from "react";
import { BrowserRouter, Link, Navigate, Route, Routes } from "react-router-dom";
import { Summary } from "./summary/Summary";
import { Overview } from "./overview/Overview";
import { ChartOverview } from "./chart/ChartOverview";
import { CsvDownload } from "./csv-download/CsvDownload";
import { ChartMaterial } from "./chart/ChartMaterial";
import { CognitoIdentityServiceProvider } from "aws-sdk";

const menus = [
  {
    name: "Chart",
    link: "/chart",
    element: <ChartOverview />,
  },
  {
    name: "Summary",
    link: "/summary",
    element: <Summary />,
  },
  {
    name: "CSV File Download",
    link: "/csv",
    element: <CsvDownload />,
  },
];

export function Root(props: { signOut?: SignOut; user?: any }) {
  const handleSignOut = async () => {
    if (props.signOut) {
      const refreshToken = props.user?.getSignInUserSession()?.getRefreshToken().getToken();
      if (refreshToken) {
        const cognitoIdentityServiceProvider = new CognitoIdentityServiceProvider({
          region: process.env.REACT_APP_AWS_REGION
        });
        const params = {
          ClientId: process.env.REACT_APP_AWS_USER_POOLS_CLIENT_ID || "",
          Token: refreshToken
        };
        try {
          cognitoIdentityServiceProvider.revokeToken(params);
        } catch (error) {
          console.error('Failed to revoke token', error);
        }
      }
      props.signOut();
    }
  }

  return (
    <BrowserRouter>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "background.default",
        }}
      >
        <AppBar position="static">
          <Toolbar sx={{ backgroundColor: "#00B0B9" }}>
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/logo_small.png`}
              sx={{ height: "55px", pt: "4px", pb: "4px" }}
            />
            <Box sx={{ flexGrow: 1 }} />
            <PersonIcon />
            <Typography sx={{ pl: 1, pr: 1 }}>
              {props.user?.username}
            </Typography>
            <IconButton title="logout" onClick={handleSignOut}>
              <LogoutIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "row" }}>
          <Box sx={{ width: 200, backgroundColor: "#F9F9F9" }}>
            <Menu />
          </Box>
          <Box sx={{ flexGrow: 1, width: "calc(100% - 250px)" }}>
            <Routes>
              {menus.map(({ link, element }, i) => (
                <Route key={i} path={link} element={element} />
              ))}
              <Route path="chart/:materialId" element={<ChartMaterial />} />
              <Route path="overview/:materialId" element={<Overview />} />
              <Route
                path="/"
                element={<Navigate to={menus[0].link} replace />}
              />
              <Route path="*" element={"Not Found"} />
            </Routes>
          </Box>
        </Box>
      </Box>
    </BrowserRouter>
  );
}

function Menu(props: {}) {

  return (
    <List>
      {menus.map(({ name, link }, i) => {
        return (
          <Link key={i} to={link} className="raw-text-link">
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemText primary={name} />
              </ListItemButton>
            </ListItem>
          </Link>
        );
      })}
    </List>
  );
}
